import { formatPhoneNumber } from '../../../lib/numUtils';
import getContactDetailId from './getContactDetailId.js';
import mapServicesToSnakeCase from '../../../lib/mapServicesToSnakeCase.js';
import { formatDateForDatabase } from 'components/LeadDataTodoEditor';
import buildSchedulingContactPayload from 'lib/buildSchedulingContactPayload.js';

const buildCreateCustomerPayload = (inputs, { contactDetailTypes, activeNonLeadMessage, utmSources, serviceProviderId, additionalContactDetails }) => {
  const contactDetails = [];
  const additionalContact = buildSchedulingContactPayload(activeNonLeadMessage);

  contactDetails.push(
    !inputs.phone_number
      ? undefined
      : {
          value: formatPhoneNumber(String(inputs.phone_number).replace(/[- )(]/g, '')),
          detail_type_id: (contactDetailTypes.find((n) => n.type === 'phone') || {}).id,
        }
  );
  contactDetails.push(
    !inputs.email_address
      ? undefined
      : {
          value: inputs.email_address,
          detail_type_id: (contactDetailTypes.find((n) => n.type === 'email') || {}).id,
        }
  );

  (additionalContactDetails || []).forEach((n) => {
    const key = getContactDetailId(n) || n.id || n.label;
    if (inputs[key] && n.detailTypeId) {
      contactDetails.push({
        value: inputs[key],
        detail_type_id: n.detailTypeId,
        detail_sub_type_id: n.detailSubTypeId,
      });
    }
  });

  const statusId = inputs.status_id || inputs.statusId || '1';
  let subStatusId = inputs.sub_status_id || inputs.subStatusId || undefined;
  if (!subStatusId && statusId === '1') {
    subStatusId = '1';
  }

  const payload = {
    business_name: inputs.business_name,
    event_id: (activeNonLeadMessage || {}).id,
    event_type: (activeNonLeadMessage || {}).type,
    first_name: inputs.first_name,
    last_name: inputs.last_name,
    contacts: [
      {
        primary: true,
        first_name: inputs.first_name,
        last_name: inputs.last_name,
        title: inputs.title,
        gender: inputs.gender,
        details: contactDetails.filter((n) => n !== undefined),
        assign_to_pipeline: !additionalContact
       },
      additionalContact,
    ].filter((n) => !!n),
    pipeline_id: inputs.pipeline_id,
    pipeline_stage_id: inputs.pipeline_stage_id,
    pipeline_user_id: inputs.pipeline_user_id,
    service_location_id: inputs.service_location_id,
    service_person_id: inputs.service_person_id,
    service_provider_id: serviceProviderId,
    utm_campaign: inputs.utm_campaign,
    utm_medium: inputs.utm_medium,
    utm_source: utmSources.filter((n) => n.name === inputs.utm_source).map((n) => n.value)[0] || inputs.utm_source,
    service_interests: mapServicesToSnakeCase(inputs.service_interests),
    status_id: statusId,
    sub_status_id: subStatusId,
    note: inputs.note,
    status_date: inputs.statusDate ? formatDateForDatabase(inputs.statusDate) : null,
  };

  return payload;
};

export default buildCreateCustomerPayload;
